import styled from "styled-components";

export const Container = styled.div`
  background-color: var(--secondary-color);
  width: 300px;
  border-radius: 5px 5px 50px 5px;
  margin: 20px;
  padding: 1rem 1rem 5px;
  position: relative;

  .buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 1rem;
    right: 1rem;
  }

  .buttonExtend {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .backExtend {
    background-color: transparent;
    border: none;
    color: var(--secondary-color);
  }
`;

export const Title = styled.p`
  color: var(--details-color);
  margin-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 230px;
  font-size: 1.2rem;
  font-weight: bolder;
`;

export const Type = styled.div`
  color: var(--primary-color);
  margin-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 230px;
`;
